// eslint-disable-next-line max-len
export default (paymentInfo: any) => {
  const {
    amount, remaining, max, min, over, partial,
  } = paymentInfo;

  if (amount > remaining && over === false) {
    return 'Payment amount cannot exceed remaining balance.';
  }
  if (amount < remaining && partial === false) {
    return 'Payment amount cannot be less than remaining balance.';
  }
  if (amount > max && amount > remaining) {
    return `Payment amount cannot exceed $${max}`;
  }
  if (amount <= 0) {
    return 'Enter an amount greater than $0.00';
  }
  // eslint-disable-next-line max-len
  if (amount < min && amount < remaining && min !== 0) {
    return `Enter an amount of at least $${min}`;
  }
  return false;
};
